export const getAdStatus = ad => {
  const status =
    ad.campaign &&
    ad.campaign.status === "ACTIVE" &&
    ad.adset &&
    ad.adset.status === "ACTIVE" &&
    ad.status === "ACTIVE"

  if (status) {
    return "ACTIVE"
  }

  return ad.status === "ACTIVE" ? "PAUSED" : ad.status
}
